import * as React from 'react';
import { cn } from '@pulsex/utils';
import { AsideEmptyColumn } from '@/ui/AsideEmptyColumn/Index';
import { TitleSection } from '@/ui/Title/Index';

export interface SectionWrapProps {
    children: React.ReactNode;
    className?: string;
    innerClassName?: string;
    emptyColumn?: boolean;
    showTitle?: boolean;
    ref?: any;
    data?: any;
    isMobile?: boolean;
    emptyDir?: 'left' | 'right' | 'center';
    disableTitle?: boolean;
    /** Promote page-level titles to h1; nested section titles stay h2. */
    headingAs?: 'h1' | 'h2';
}

export default function SectionWrap({
    children,
    className,
    innerClassName,
    emptyColumn = false,
    showTitle = true,
    data,
    isMobile,
    emptyDir = 'center',
    ref,
    disableTitle,
    headingAs = 'h2',
}: SectionWrapProps) {
    return (
        <section
            className={cn(
                'relative block w-full items-stretch gap-5 pt-8 mb-6 max-md:mb-4 max-md:pt-6',
                className
            )}
        >
            {emptyColumn && emptyDir === 'center' ? (
                <div className={cn(`lg:w-[calc(100%-180px)] lg:mx-auto block`)}>
                    {emptyDir === 'center' && data?.title && showTitle ? (
                        <TitleSection
                            title={data?.title}
                            moreUrl={!disableTitle ? data?.moreLink : undefined}
                            isMobile={isMobile}
                            as={headingAs}
                        />
                    ) : (
                        ''
                    )}
                    {children}
                </div>
            ) : (
                <>
                    {data?.title && showTitle ? (
                        <TitleSection
                            title={data?.title}
                            moreUrl={data?.moreLink}
                            isMobile={isMobile}
                            as={headingAs}
                        />
                    ) : (
                        ''
                    )}
                    <div className={cn('flex max-lg:flex-col w-full', innerClassName)}>
                        {emptyColumn ? (
                            <>
                                {emptyDir === 'right' ? (
                                    <aside
                                        className="hidden lg:w-[200px] lg:max-w-[200px] lg:block"
                                        aria-hidden="true"
                                    />
                                ) : (
                                    ''
                                )}

                                <div className={cn('lg:w-[calc(100%-180px)]')}>{children}</div>

                                {emptyDir === 'left' ? (
                                    <aside
                                        className="hidden lg:w-[180px] lg:max-w-[200px] lg:block"
                                        aria-hidden="true"
                                    />
                                ) : (
                                    ''
                                )}
                            </>
                        ) : (
                            children
                        )}
                    </div>
                </>
            )}
        </section>
    );
}
